import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'fun-register-taxdown-code',
  templateUrl: './register-taxdown-code.component.html',
  styleUrls: ['./register-taxdown-code.component.scss'],
})
export class RegisterTaxdownCodeComponent implements OnInit, AfterViewInit {

  @Output() public sendValueEvent = new EventEmitter<any>();

  parentForm: UntypedFormGroup;
  elements: any;
  public formControlKeys = [];
  public formControlKeysRep = [];
  public formControlKeysCompany = [];
  public errorMessages = {};
  public isSubmit = false;
  public errorAmount = false;

  constructor(public chdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.parentForm = new UntypedFormGroup({
      code: new UntypedFormControl('', []),
    });
    this.chdRef.detectChanges();
  }

  ngAfterViewInit() {
    this.chdRef.detectChanges();
  }

  validate() {
    if (this.parentForm.valid) {
      this.sendValueEvent.emit(this.parentForm.value);
    }
    this.chdRef.detectChanges();
  }

}
